import { SignalLevel } from "../constants";

/**
 * 信号等级映射工具类
 * 根据技术指标的综合信号分数，返回对应的信号等级
 *
 * @param totalSignalPoints 综合信号分数，范围通常在 [-1.0, 1.0] 之间
 * @returns 信号等级枚举值
 *
 * 映射规则：
 * - Strong Buy：平均分数在 (0.5, 1.0] 范围内（即大于0.5且小于等于1.0）
 * - Buy：平均分数在 (0.1, 0.5] 范围内（即大于0.1且小于等于0.5）
 * - Neutral：平均分数在 [-0.1, 0.1] 范围内
 * - Sell：平均分数在 [-0.5, -0.1) 范围内（即大于等于-0.5且小于-0.1）
 * - Strong Sell：平均分数在 [-1.0, -0.5) 范围内（即大于等于-1.0且小于-0.5）
 */
export const signalLevelMap = (totalSignalPoints: number): SignalLevel => {
  // 参数验证：确保输入是有效数字
  if (typeof totalSignalPoints !== "number" || isNaN(totalSignalPoints)) {
    return SignalLevel.NEUTRAL;
  }

  // 边界值处理：确保分数在合理范围内
  const clampedScore = Math.max(-1.0, Math.min(1.0, totalSignalPoints));

  // 根据分数区间返回对应的信号等级
  if (clampedScore > 0.5 && clampedScore <= 1.0) {
    return SignalLevel.STRONG_BUY;
  }

  if (clampedScore > 0.1 && clampedScore <= 0.5) {
    return SignalLevel.BUY;
  }

  if (clampedScore >= -0.1 && clampedScore <= 0.1) {
    return SignalLevel.NEUTRAL;
  }

  if (clampedScore >= -0.5 && clampedScore < -0.1) {
    return SignalLevel.SELL;
  }

  // 剩余情况：clampedScore >= -1.0 && clampedScore < -0.5
  return SignalLevel.STRONG_SELL;
};
